var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar',{attrs:{"brandName":_vm.marketBrand,"brandHref":_vm.anonMarket ? _vm.$router.resolve({name: 'user-login', params: { marketId: _vm.anonMarket.marketId }}).location : _vm.$router.resolve({name: 'base'}).location}}),_c('router-view'),_c('custom-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }